import styled from 'styled-components';

const MentorContent = styled.div`
  display:flex;
  align-content:center;
  flex-direction: column;
`;

export default MentorContent;
